"use strict";

var _classCallCheck = require("/code/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/code/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwinkleValues = void 0;

var OptionsColor_1 = require("../../OptionsColor");

var TwinkleValues = /*#__PURE__*/function () {
  function TwinkleValues() {
    _classCallCheck(this, TwinkleValues);

    this.enable = false;
    this.frequency = 0.05;
    this.opacity = 1;
  }

  _createClass(TwinkleValues, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.color !== undefined) {
        this.color = OptionsColor_1.OptionsColor.create(this.color, data.color);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.frequency !== undefined) {
        this.frequency = data.frequency;
      }

      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);

  return TwinkleValues;
}();

exports.TwinkleValues = TwinkleValues;